export const optimizeImage = (src: string, width: number = 800) => {
  // If using a CDN or image optimization service, you can add the transformation parameters here
  return src;
};

export const getImageProps = (src: string, alt: string, width: number = 800, height?: number) => {
  return {
    src,
    alt,
    width,
    height,
    loading: "lazy" as const,
    decoding: "async" as const,
  };
}; 